module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Profile_Black.e3f224fe.svg";